import { buildDetailTabSearch } from "@/components/detail-page/_helpers/detail-tab-search";

export enum GroupDetailTab {
  Rules = "rules",
  Users = "users",
  AppRoles = "app-roles",
}

export function createGroupDetailPath(groupUuid: string, tab: GroupDetailTab): string {
  return `~/ram/group/${groupUuid}${buildDetailTabSearch(tab)}`;
}
